import React, { useContext, useEffect } from "react";
import { Table } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";

interface IProps {
  id: string;
}

const NotificationHistory: React.FC<IProps> = ({ id }) => {
  const rootStore = useContext(RootStoreContext);
  const { getDocumentNotifications, documentNotification } = rootStore.invoiceStore;
  useEffect(() => {
    getDocumentNotifications(id);
  }, [getDocumentNotifications, id]);
  return (
    <div className="TableScroll">   
      <Table striped basic unstackable compact>
        <Table.Header >
          <Table.Row>
            <Table.HeaderCell>Fecha de Acción</Table.HeaderCell>
            <Table.HeaderCell>Acción</Table.HeaderCell>
            <Table.HeaderCell>Observaciones</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {documentNotification?.length > 0 ? (
            documentNotification.map((trace) => (
              <Table.Row key={trace.trackId}>
                <Table.Cell singleLine>
                  {trace.actionDate}
                </Table.Cell>
                <Table.Cell singleLine>{trace.action}</Table.Cell>
                {trace.observations.length > 0 ? (
                  trace.observations.map((ob) => (
                    <Table.Row key={`${trace.trackId}-${ob.code}`}>
                      <Table.Cell>{ob.message}</Table.Cell>
                    </Table.Row>
                  ))
                ) : (
                  <Table.Row >
                    <Table.Cell ></Table.Cell>
                  </Table.Row>
                )}
              </Table.Row>
            ))
          ) : (
            <Table.Row key="documentNotificationNull">
              <Table.Cell>No existen notificaciones </Table.Cell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    </div>
  );
};

export default observer(NotificationHistory);
